import React from 'react';
import classNames from 'classnames';

interface ComponentProps {
  title: string;
  description?: React.ReactNode;
  subDescription?: string;
  className?: string;
  headerRight?: React.ReactNode;
  /**
   * Opt-in. Rendered inline immediately after the title text, inside the header row (for example one info icon that
   * explains the section). Kept outside the heading element so the heading's accessible name stays the title alone.
   */
  titleAddon?: React.ReactNode;
  /** Heading element for the title — pick to preserve the page's heading order. */
  titleTag?: 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
  dataCy?: string;
  children: React.ReactNode;
}

const SectionCard: React.FC<ComponentProps> = ({
  title,
  description,
  subDescription,
  className,
  headerRight,
  titleAddon,
  titleTag: TitleTag = 'h5',
  dataCy,
  children,
}) => {
  const localClassName = classNames('section-card-container', className);
  const titleElement = <TitleTag className="section-card-title">{title}</TitleTag>;
  return (
    <div className={localClassName} data-cy={dataCy}>
      <div className="section-card-header">
        {titleAddon ? (
          <div className="section-card-title-group">
            {titleElement}
            <span className="section-card-title-addon">{titleAddon}</span>
          </div>
        ) : (
          titleElement
        )}
        {headerRight && <div className="section-card-header-right">{headerRight}</div>}
      </div>
      {description && <p className="section-card-description">{description}</p>}
      {subDescription && <p className="section-card-sub-description">{subDescription}</p>}
      <div>{children}</div>
    </div>
  );
};

export default SectionCard;
